// extracted by mini-css-extract-plugin
module.exports = {"container":"_2lVPmYrbpr70U_p7i2eFnz","icon":"_2etOuS3Vshv98d1sggJRF5"};